import React from "react";
import "../../../i18n";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DigitalCardsManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">{t("admin_digital_cards.title")}</h4>
            <div className="d-flex flex-column gap-2 mt-4 align-items-start">
              <Link to="/digital-cards/list" className="btn btn-primary">
                {t("admin_digital_cards.buttons.list")}
              </Link>
              <Link
                to="/digital-cards/active"
                className="btn btn-outline-primary"
                style={{ backgroundColor: "#7EC8FF", borderColor: "#7EC8FF", color: "#ffffff" }}
              >
                {t("admin_digital_cards.buttons.active")}
              </Link>
              <Link
                to="/digital-cards/create"
                className="btn btn-success"
                style={{ backgroundColor: "#D97ADF", borderColor: "#D97ADF", color: "#ffffff" }}
              >
                {t("admin_digital_cards.buttons.create")}
              </Link>
              <Link
                to="/digital-cards/edit"
                className="btn btn-success"
                style={{ backgroundColor: "#A8E06E", borderColor: "#A8E06E", color: "#ffffff" }}
              >
                {t("admin_digital_cards.buttons.edit")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalCardsManagement;
